import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FKBreadCrumb = _resolveComponent("FKBreadCrumb")!
  const _component_InviteUserForm = _resolveComponent("InviteUserForm")!
  const _component_InvitationList = _resolveComponent("InvitationList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FKBreadCrumb, {
      page: _ctx.$t('page.invite_user'),
      title: _ctx.$t('page.invite_user')
    }, null, 8 /* PROPS */, ["page", "title"]),
    _createVNode(_component_InviteUserForm),
    _createVNode(_component_InvitationList)
  ], 64 /* STABLE_FRAGMENT */))
}